import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../../Text';
import TextInput from '../../FormStyles/TextInput.jsx';
import { Button } from '../../FormStyles/Button';
import { sanitizeIframe } from './sanitizeIframe';

const EmbedVideo = ({ setEmbedVideo, closeContent }) => {
  const { t } = useTranslation('tileForm');
  const [value, setValue] = useState('');
  const [isValid, setIsValid] = useState();

  const handleChange = inputValue => {
    setValue(inputValue);
    const iframe = sanitizeIframe(inputValue);

    if (iframe) {
      setIsValid(true);
      setEmbedVideo({ videoIframe: iframe });
    } else {
      setIsValid(false);
    }
  };

  return (
    <>
      <EmbedHelp
        href={t('media.helpEmbedVideoLink')}
        as="a"
        color="primary.100"
      >
        {t('media.helpEmbedVideo')}
      </EmbedHelp>
      <TextInput
        placeholder={t('media.embedVideoInputPlaceholder')}
        as="textarea"
        value={value}
        onChange={e => handleChange(e.target.value)}
      />
      {isValid === false && (
        <Text as="div" color="error.default" pt="16px">
          {t('media.invalidEmbedUrl')}
        </Text>
      )}
      <Button
        variant="containedBlue"
        width="100%"
        mt="20px"
        onClick={closeContent}
      >
        {t('media.closeSearch')}
      </Button>
    </>
  );
};

export default EmbedVideo;

const EmbedHelp = styled(Text)`
  display: flex;
`;
